// extracted by mini-css-extract-plugin
export default {"content":"LightComponent_content__egobr"};